import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_REPORT } from "../report.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateReportInput } from "../../../__generated__/globalTypes";
import {
  UpdateReportMutation,
  UpdateReportMutationVariables,
} from "../../../__generated__/UpdateReportMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateReport = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateReportInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateReportMutation,
    UpdateReportMutationVariables
  >(UPDATE_REPORT, {
    refetchQueries: ["ReportsQuery", "ReportQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateReport?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateReport?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
